<template>

    <m-edit1/>

    <m-Alert-1 v-bind='{...{},...{}}' :style='""' class="col-11 mx-auto mt-2 text-center" >
                <template #default>(ارسال بصورت پس کرایه می باشد. ثبت سفارش بدون پرداخت هزینه می باشد، پس از ثبت سفارش همکاران ما با شما تماس می گیرند)   </template>
                </m-Alert-1><m-verify-transaction-1 v-bind='{...{},...{}}' :style='""' class="my-5 container" ></m-verify-transaction-1>

</template>

<script>
import mEdit1 from '@moeinmdn/miw-alpha-components/src/package/Tool/Edit/Edit1'
import {appendTagsToPage} from "@moeinmdn/mixitweb-front-modules/src/plugin/class/Seo";

import mAlert1 from '@moeinmdn/miw-alpha-components/src/package/Alert/Alert1'; import mVerifyTransaction1 from '@moeinmdn/miw-alpha-components/src/package/ShoppingCart/VerifyTransaction/VerifyTransaction1';

export default {
    name: 'HomeView',
    components: {mEdit1, mAlert1,mVerifyTransaction1 },
    mounted() {
       if(this.$route.name === 'Home'){
           appendTagsToPage({}, 'home')
       }
    },
}
</script>


<style scoped>

</style>
